// src/services/tour.service.js
import api from './api';

const tourService = {
  // Submit Start KM
  startKm: async (data) => {
    try {
      const response = await api.post('/tours/start-km', data);
      return response.data;
    } catch (error) {
      console.error('Error submitting start KM:', error);
      throw error;
    }
  },

  // Submit End KM
  endKm: async (data) => {
    try {
      const response = await api.post('/tours/end-km', data);
      return response.data;
    } catch (error) {
      console.error('Error submitting end KM:', error);
      throw error;
    }
  },

  // Get today's tour entry
  getTodayTour: async () => {
    try {
      const response = await api.get('/tours/today');
      return response.data;
    } catch (error) {
      console.error('Error fetching today tour:', error);
      throw error;
    }
  },

  // Get monthly tours + stats
  getMonthlyTours: async (year, month) => {
    try {
      const params = {};
      if (year) params.year = year;
      if (month) params.month = month;
      const response = await api.get('/tours/monthly', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching monthly tours:', error);
      throw error;
    }
  },

  // Get traveling with employees
  getTravelingWithEmployees: async () => {
    try {
      const response = await api.get('/tours/traveling-with');
      return response.data;
    } catch (error) {
      console.error('Error fetching employees:', error);
      throw error;
    }
  },

  // Get team tours (hierarchical — backend filters by role)
getTeamTours: async (fromDate, toDate, page = 1, limit = 20) => {
  try {
    const params = { fromDate, toDate, page, limit };
    const response = await api.get('/tours/team', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching team tours:', error);
    throw error;
  }
},
 
// Get farmer visits for a specific tour entry
getTourVisits: async (tourId) => {
  try {
    const response = await api.get(`/tours/team/${tourId}/visits`);
    return response.data;
  } catch (error) {
    console.error('Error fetching tour visits:', error);
    throw error;
  }
},
};

export default tourService;